"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.ListContainer = exports.ListItem = exports.NextButton = exports.PreviousButton = void 0;

var _baseui = require("baseui");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var buttonStyle = {
  position: 'absolute',
  top: '0',
  bottom: '0',
  cursor: 'pointer',
  backgroundColor: 'rgba(0,0,0,0.5)',
  border: 'none',
  color: 'white',
  minWidth: '40px',
  fontSize: '18px',
  transform: 'scale(1, 2)',
  ':focus': {
    outline: '0'
  },
  ':hover': {
    backgroundColor: 'rgba(0,0,0,0.7)'
  }
};
var PreviousButton = (0, _baseui.styled)('button', function (_ref) {
  var $visible = _ref.$visible;
  return _objectSpread({}, buttonStyle, {
    display: $visible ? 'block' : 'none',
    left: '0'
  });
});
exports.PreviousButton = PreviousButton;
var NextButton = (0, _baseui.styled)('button', function (_ref2) {
  var $visible = _ref2.$visible;
  return _objectSpread({}, buttonStyle, {
    display: $visible ? 'block' : 'none',
    right: '0'
  });
});
exports.NextButton = NextButton;
var ListItem = (0, _baseui.styled)('li', function (_ref3) {
  var $theme = _ref3.$theme;
  return {
    marginRight: $theme.sizing.scale100,
    boxSizing: 'border-box'
  };
});
exports.ListItem = ListItem;
var ListContainer = (0, _baseui.styled)('ul', {
  listStyleType: 'none',
  margin: '0 auto -15px auto',
  padding: '0 0 15px 0',
  width: '100%',
  height: '100%',
  display: 'flex',
  overflowX: 'auto',
  overflowY: 'hidden',
  scrollbarWidth: 'none'
  /* Firefox */
  ,
  '-ms-overflow-style': 'none'
  /* Internet Explorer 10+ */
  ,
  transition: 'transform .5s ease-in'
});
exports.ListContainer = ListContainer;
var Root = (0, _baseui.styled)('div', {
  width: '100%',
  overflow: 'hidden',
  position: 'relative'
});
exports.Root = Root;